// extracted by mini-css-extract-plugin
export var actions = "pwa-install-bar-module--actions--a0562";
export var closeButton = "pwa-install-bar-module--close-button--9a745";
export var container = "pwa-install-bar-module--container--920b2";
export var inner = "pwa-install-bar-module--inner--b77fa";
export var installButton = "pwa-install-bar-module--install-button--0f293";
export var text = "pwa-install-bar-module--text--77c2a";